import changelogData from "@/assets/changelog.json";
import { APP_VERSION } from "@/config/appInfo";

export type ChangelogEntry = {
  version: string;
  date: string;
  title?: string;
  highlights: string[];
  improvements?: string[];
  fixes?: string[];
};

export type ChangelogMap = Record<
  string,
  {
    date: string;
    title?: string;
    highlights: string[];
    improvements?: string[];
    fixes?: string[];
  }
>;

const changelog = changelogData as ChangelogMap;

const getChronologicalDate = (value?: string) => new Date(value ?? 0).getTime();

export const getChangelogEntries = (): ChangelogEntry[] => {
  return Object.entries(changelog)
    .map(([version, entry]) => ({ version, ...entry }))
    .sort((a, b) => getChronologicalDate(b.date) - getChronologicalDate(a.date));
};

export const getDismissalStorageKey = (version: string) => `whatsNewDismissed:${version}`;

export const isVersionDismissed = (version: string = APP_VERSION) => {
  if (typeof window === "undefined") return false;
  return window.localStorage.getItem(getDismissalStorageKey(version)) === "true";
};

export const dismissVersion = (version: string = APP_VERSION) => {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(getDismissalStorageKey(version), "true");
};

export const resetVersionDismissal = (version: string = APP_VERSION) => {
  if (typeof window === "undefined") return;
  window.localStorage.removeItem(getDismissalStorageKey(version));
};
